import "./CannedResponseHeader.scss";
import Heading from "components/ui/Heading/Heading";
import PaginationSearch from "components/ui/InputTypes/InputSearch/PaginationSearch/PaginationSearch";
import AddButton from "components/ui/Button/AddButton/AddButton";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { CANNED_RESPONSE_CREATE_PERMISSION } from "components/dashboard/KnowledgeBase/CannedResponses/permissions";

const CannedResponseHeader = ({
    title,
    subTitle,
    btnText,
    placeholder,
    handleClick,
    handleSearch,
    searchIsLoading,
    clearSearch,
    defaultValue,
}) => {
    return (
        <>
            <Heading headingText={title} headingSubText={subTitle} />
            <div className='canned-response-header'>
                <PaginationSearch
                    placeholder={placeholder}
                    {...{
                        handleSearch,
                        searchIsLoading,
                        clearSearch,
                        defaultValue,
                    }}
                />
                <ComponentAccessControl
                    baseResources={CANNED_RESPONSE_CREATE_PERMISSION}>
                    <AddButton
                        btnText={btnText}
                        onClick={() => handleClick?.()}
                    />
                </ComponentAccessControl>
            </div>
        </>
    );
};

export default CannedResponseHeader;
